<cdk-virtual-scroll-viewport class="virt-container" [itemSize]="itemSize">
  <ng-container *cdkVirtualFor="let item of flattenedList">
    <div style="margin: 0px 5px" (dragover)="OnDragOver($event, item)" (dragleave)="OnDragLeave($event, item)"
      (drop)="OnDrop($event, item)">
      @switch (item.itemType) {
        @case (itemType.MonthCW) {
          <div style="padding: 0px 5px" [ngStyle]="GetItemSizeStyle()">
            <legend>
              <button mat-button [style.height]="itemSize + 'px'" (click)="OnSelectAll(item, $event)">
                <div class="heading" [ngClass]="items && items.length > 0 && items[0].Type === collectionType.YearMonth ? 'heading--month' : 'heading--cw-or-day'" >
                  <span>{{ item.display }}</span>
                  <span class="subtopic">{{ item.subDisplay }}</span>
                </div>
              </button>
            </legend>
          </div>
        }
        @case (itemType.Resource) {
          <div style="padding: 0px 5px; margin-left: 20px"
            [ngStyle]="GetItemSizeStyle()" class="grid-resource-item">
            <div class="grid-cell-resource-label">
              <button mat-button [style.height]="itemSize + 'px'" style="text-transform: none" (click)="OnSelectAll(item, $event)">
                <legend class="legendSmall">
                  {{ item.name }} ({{ item.tasks.length }})
                </legend>
              </button>
            </div>
            @if (
              !isSaasInstance &&
              item.resType === resourceType.User &&
              (item.contextInfo?.type === collectionType.CalendarWeek ||
              item.contextInfo?.type === collectionType.Day)
              ) {
              <div
                class="grid-cell-absence-panel">
                @for (absence of getDisplayedAbsencesForItem(item); track absence) {
                  <div class="absence-card" [ngClass]="'absence-card--' + absence.type" [title]="absence.tooltip">
                    <span>{{ absence.label }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        @case (itemType.TaskCard) {
          <div style="padding: 0px 5px; margin-left: 30px">
            <div draggable="true" class="task-card-chromium" [ngStyle]="GetSelectedStyle(item.task)"
              (dragstart)="OnDragStart($event, item)">
              <app-planung-task-card [task]="item.task" [resources]="overview.Resources"
                [taskStates]="overview.TaskStates" [taskStateMetas]="overview.TaskStateMetas" [handlesDragDrop]="false"
                [showTooltip]="overview.uiState.ShowTaskCardTooltips" [displayResourceName]="item.displayResource"
                [displayTaskLocationInTitle]="true" (contextmenu)="overview.onRightClick($event)"
                (mouseup)="overview.selection.HandleItem(item.task, $event)">
              </app-planung-task-card>
            </div>
          </div>
        }
      }
    </div>
  </ng-container>
</cdk-virtual-scroll-viewport>